import { STATES } from '@/lib/states';

const CONFIG = {
  [STATES.IDLE]: { label: 'Listo para grabar', cls: 'bg-secondary text-secondary-foreground' },
  [STATES.RECORDING]: { label: 'Grabando…', cls: 'bg-destructive text-destructive-foreground' },
  [STATES.TRANSCRIBING]: { label: 'Transcribiendo audio…', cls: 'bg-accent text-accent-foreground' },
  [STATES.THINKING]: { label: 'Procesando…', cls: 'bg-accent text-accent-foreground' },
  [STATES.CLARIFY]: { label: 'Falta información', cls: 'bg-accent text-accent-foreground' },
  [STATES.CONFIRMING]: { label: 'Esperando tu confirmación', cls: 'bg-primary text-primary-foreground' },
  [STATES.CALCULATING]: { label: 'Calculando carbohidratos…', cls: 'bg-accent text-accent-foreground' },
  [STATES.RESULT]: { label: 'Resultado listo', cls: 'bg-primary text-primary-foreground' },
  [STATES.ERROR]: { label: 'Hubo un problema', cls: 'bg-destructive text-destructive-foreground' },
};

export const StatusBadge = ({ state }) => {
  const { label, cls } = CONFIG[state] || CONFIG[STATES.IDLE];
  const busy = [STATES.TRANSCRIBING, STATES.THINKING, STATES.CALCULATING].includes(state);
  return (
    <div
      className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold ${cls}`}
      data-testid="status-badge"
    >
      {busy && <span className="h-2 w-2 rounded-full bg-current animate-pulse" />}
      {state === STATES.RECORDING && <span className="h-2 w-2 rounded-full bg-current animate-pulse" />}
      {label}
    </div>
  );
};
